import { Link } from 'react-router-dom';
import * as C from './styles.js';
import { FaXmark } from "react-icons/fa6";
import Tabs from './componentes/tabs/index.js';
import Season from './componentes/components/seasons/season/index.js';
import Episode from './componentes/components/seasons/episode/index.js';

export default function PopUpDetails({ tab, temporada, episodio, linkBack, media_type, movie_id, movie_id_imdb, movie_data, movie_data_db, background_color }) {

    return (
        <C.Container background_color={background_color}>
            <C.Content>
                
                {!temporada &&
                    <>
                        <header>
                            <Link to={linkBack}><FaXmark size={20} color='#fff'/></Link>
                        </header>
                        <Tabs tab={tab} linkBase={linkBack} media_type={media_type} movie_id={movie_id} movie_id_imdb={movie_id_imdb} movie_data={movie_data} movie_data_db={movie_data_db}/>
                    </>
                }
                <div className={(temporada && !episodio) ? '' : 'hidden-component'}>
                    <Season season_number={temporada} linkBase={linkBack} movie_data={movie_data} media_type={media_type} movie_id={movie_id} movie_id_imdb={movie_id_imdb} />
                </div>
                <div className={(temporada && episodio) ? '' : 'hidden-component'}>
                    <Episode season_number={temporada} linkBase={linkBack} movie_data={movie_data} media_type={media_type} movie_id={movie_id} movie_id_imdb={movie_id_imdb} />
                </div>
            </C.Content>
        </C.Container>
    )
}